import type { OperationVariables, TypedDocumentNode } from "@apollo/client";
import { MAX_GLOBAL_SEARCH_OPTIONS } from "@/constants";
import type { GlobalSearchApolloClient } from "@/components/Navigation/GlobalHeader/GlobalSearch/types";

export const GLOBAL_SEARCH_PAGINATION_DEFAULTS = {
  first: MAX_GLOBAL_SEARCH_OPTIONS,
  after: undefined,
  order: [],
};

type ExecuteGlobalSearchQueryParams<TData, TVars extends OperationVariables> = {
  client: GlobalSearchApolloClient;
  query: TypedDocumentNode<TData, TVars>;
  variables: TVars;
  signal?: AbortSignal;
};

export async function executeGlobalSearchQuery<
  TData,
  TVars extends OperationVariables,
>({
  client,
  query,
  variables,
  signal,
}: ExecuteGlobalSearchQueryParams<TData, TVars>): Promise<TData | undefined> {
  const { data } = await client.query<TData, TVars>({
    query,
    variables,
    fetchPolicy: "no-cache",
    context: { fetchOptions: { signal } },
  });
  return data ?? undefined;
}
